document.querySelectorAll('.product-carousel').forEach(function(Element,index){
  let productid = Element.dataset.id;
  let slider = new Splide(Element, {
    perPage: 4,
    perMove: 1,
    gap: "8px",
    breakpoints: {
      992: {
        perPage: 2
      }
    },
    classes: {
      arrows: 'splide__arrows splid-cus-arrows',
      arrow : 'splide__arrow splid-cus-arrows',
      prev  : 'splide__arrow--prev splid-cus-prev',
      next  : 'splide__arrow--next splid-cus-next',
    }
  }).mount();
});